import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'maskSensitive', standalone: true })
export class MaskSensitivePipe implements PipeTransform {

  transform(
    value: string | null,
    visibleDigits: number = 4,
    maskChar: string = '•'
  ): string {
    if (!value) return '';

    const maskedLength = Math.max(value.length - visibleDigits, 0);
    return maskChar.repeat(maskedLength) + value.slice(-visibleDigits);
  }
}
